module.exports = __webpack_public_path__ + "static/shadows-application-do-3badd770e818230b6548641a98ccc17e.png";